import styled from "styled-components";

export const DeviceManagementWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    position: relative;
`;

export const DeviceOverviewWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
`;

export const ToolBarWrapper = styled.div`
    box-sizing: border-box;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 10px 2px 10px;
    width: 100%;
`;

export const FilterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;


    & .ant-select-selector {
        overflow: hidden;
    }

    & .ant-select-selection-overflow {
        flex-wrap: nowrap;
    }
`;

export const FilterItemLabel = styled.div`
    font-size: 12px;
    color: #333333;
    text-align: left;
    padding-left: 10px;
    box-sizing: border-box;
    letter-spacing: 2px;
`;

export const DeviceCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-rows: min-content;
  gap: 16px;
  padding: 16px;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
  }

  @media (min-width: 1200px) {
    grid-template-columns : repeat(auto-fill, minmax(320px, 1fr));
  }
`;

export const DeviceCardWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 14px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 90px;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    border-color: #d0d0d0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
`;

export const Name = styled.div`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  flex: 1;
  padding-right: 8px;
`;

export const Status = styled.div`
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
`;

export const InfoLabel = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 400;
  line-height: 1.4;
`;

export const InfoValue = styled.div`
  font-size: 14px;
  color: #333;
  font-weight: 500;
  line-height: 1.4;
  margin-bottom: 4px;
  
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const LastLine =  styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ViewDetailButton = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #0f3363;
  border-bottom: 1px dashed #0f3363;
  line-height: 1.2; 
  padding-bottom: 2px; 
  white-space: nowrap; 
`;

export const PaginationWrapper = styled.div`
    display: flex;
    display: flex;
    justify-content: center;
    padding: 16px;
    border-top: 1px solid #f0f0f0;
    background: #fff;
    
    .ant-pagination {
        margin: 0;
    }
`;
